
<div class="uploader-status">
<mat-progress-spinner class="spinner" mode="indeterminate" diameter="200">
</mat-progress-spinner>
</div>